module.exports = __webpack_public_path__ + "static/mr-concert-performance-13-c7902d7ca29cf868e1caed86896ef648.jpg";